<template>
    <div class="form-aliases-add-group">
        <div class="form-aliases-add-group__title">
            Создание алиаса
        </div>
        <div class="form-aliases-add-group__input">
            <input
                placeholder="Введите название нового алиаса"
                v-model="groupName"
            />
        </div>
        <div class="form-aliases-add-group__btn-container">
            <button @click="onClickCancel">Отмена</button>
            <button
                v-if="groupName !== ''"
                type="submit"
                @click="onClickSubmit"
            >
                Создать
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormAliasesAddGroup',
    /**
     * данные компонента
     * @property {string} groupName - название группы
     */
    data: () => ({
        groupName: ''
    }),
    methods: {
        /**
         * событие отправки имени новой группы
         */
        onClickSubmit() {
            this.$emit('submitForm', this.groupName);
        },
        onClickCancel(){
            this.$emit('cancelForm');
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-aliases-add-group {
        height: 150px;
        width: 400px;
    }
    .form-aliases-add-group__title {
        text-align: center;
        font-size: 20px;
        margin: 20px 20px 20px 20px;
    }
    .form-aliases-add-group__input {
        text-align: center;
        margin: 20px 20px 20px 20px;
    }
    .form-aliases-add-group__input input {
        width: 100%;
    }
    .form-aliases-add-group__btn-container {
        text-align: end;
        margin: 20px 20px 20px 20px;
    }
</style>